import { render, staticRenderFns } from "./AddressbookManage.vue?vue&type=template&id=194fdb02&"
import script from "./AddressbookManage.vue?vue&type=script&lang=js&"
export * from "./AddressbookManage.vue?vue&type=script&lang=js&"
import style0 from "./AddressbookManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports